{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2017 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSWEBJSONWriter;

{$I WEBLib.TMSWEBDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$INLINE ON}{$R-}{$Q-}

interface

uses
  {$IFNDEF LCLWEBLIB}
  Generics.Collections,
  {$ENDIF}
  Classes, SysUtils, WEBLib.TMSWEBTypes;

type
  TTMSWEBJSONStreamWriter = class
  private
  var
    FStream: TStream;
    FWriteStream: TStringStream;
  public
    constructor Create(AStream: TStream);
    destructor Destroy; override;
    procedure Write(const Value: string);
  end;

  TTMSWEBJSONWriter = class
  public
    type
      ECannotWriteName = class(Exception)
      public
        constructor Create;
      end;
      EMultipleRootNotAllowed = class(Exception)
      public
        constructor Create;
      end;
      EObjectOrArrayExpected = class(Exception)
      public
        constructor Create;
      end;
      EInvalidNesting = class(Exception)
      public
        constructor Create;
      end;
      EMissingValue = class(Exception)
      public
        constructor Create;
      end;
      ETooManyDepthLevels = class(Exception)
      public
        constructor Create;
      end;
      EEmptyJson = class(Exception)
      public
        constructor Create;
      end;
      EEmptyName = class(Exception)
      public
        constructor Create;
      end;
  private
    type
      TTMSWEBJSONScope = (jscEmptyDocument, jscEmptyArray, jscEmptyObject, jscNonEmptyDocument,
        jscNonEmptyArray, jscNonEmptyObject, jscDanglingName);
    const
      MaxStackSize = 255;
  private
    FWriter: TTMSWEBJSONStreamWriter;
    FStack: array[0..MaxStackSize] of TTMSWEBJSONScope;
    FStackSize: integer;
    FIndent: string;
    FSeparator: string;
    FDeferredName: string;
    procedure SetIndentLength(const Value: integer);
    function GetIndentLength: integer;
    function OpenItem(const Empty: TTMSWEBJSONScope; const OpenBracket: string): TTMSWEBJSONWriter;
    function CloseItem(const Empty, NonEmpty: TTMSWEBJSONScope; const CloseBracket: string): TTMSWEBJSONWriter;
    procedure PushScope(const Scope: TTMSWEBJSONScope); inline;
    function PeekScope: TTMSWEBJSONScope; inline;
    procedure ReplaceTop(const Scope: TTMSWEBJSONScope); inline;
    procedure WriteDeferredName; inline;
    procedure InternalWriteString(const Value: string);
    procedure NewLine; inline;
    procedure BeforeName;
    procedure BeforeValue(const Root: boolean);
  public
    constructor Create(const AStream: TStream);
    destructor Destroy; override;
    function WriteBeginArray: TTMSWEBJSONWriter;
    function WriteEndArray: TTMSWEBJSONWriter;
    function WriteBeginObject: TTMSWEBJSONWriter;
    function WriteEndObject: TTMSWEBJSONWriter;
    function WriteName(const Name: string): TTMSWEBJSONWriter;
    function WriteString(const Value: string): TTMSWEBJSONWriter;
    function WriteRawString(const Value: string): TTMSWEBJSONWriter;
    function WriteBoolean(const Value: boolean): TTMSWEBJSONWriter;
    function WriteNull: TTMSWEBJSONWriter;
    function WriteDouble(const Value: double): TTMSWEBJSONWriter;
    function WriteInteger(const Value: Int64): TTMSWEBJSONWriter;
    procedure Close;
    property IndentLength: integer read GetIndentLength write SetIndentLength;
  end;

implementation

uses
  WEBLib.TMSWEBUtils;

{ TTMSWEBJSONWriter }

procedure TTMSWEBJSONWriter.BeforeName;
begin
  case PeekScope of
    TTMSWEBJSONScope.jscNonEmptyObject: FWriter.Write(',');
    TTMSWEBJSONScope.jscEmptyObject: ;
  else
    raise ECannotWriteName.Create;
  end;
  NewLine;
  ReplaceTop(TTMSWEBJSONScope.jscDanglingName);
end;

procedure TTMSWEBJSONWriter.BeforeValue(const Root: boolean);
begin
  case PeekScope of
    TTMSWEBJSONScope.jscNonEmptyDocument:
      raise EMultipleRootNotAllowed.Create;
    TTMSWEBJSONScope.jscEmptyDocument:
      begin
        if not Root then
           raise EObjectOrArrayExpected.Create;
        ReplaceTop(TTMSWEBJSONScope.jscNonEmptyDocument);
      end;
    TTMSWEBJSONScope.jscEmptyArray:
      begin
        ReplaceTop(TTMSWEBJSONScope.jscNonEmptyArray);
        NewLine;
      end;
    TTMSWEBJSONScope.jscNonEmptyArray:
      begin
        FWriter.Write(',');
        NewLine;
      end;
    TTMSWEBJSONScope.jscDanglingName:
      begin
        FWriter.Write(FSeparator);
        ReplaceTop(TTMSWEBJSONScope.jscNonEmptyObject);
      end;
  else
    raise EInvalidNesting.Create;
  end;
end;

function TTMSWEBJSONWriter.CloseItem(const Empty, NonEmpty: TTMSWEBJSONScope;
  const CloseBracket: string): TTMSWEBJSONWriter;
var
  Context: TTMSWEBJSONScope;
begin
  Context := PeekScope;
  if not (Context in [Empty, NonEmpty]) then
    raise EInvalidNesting.Create;
  if FDeferredName <> '' then
    raise EMissingValue.Create;
  Dec(FStackSize);
  if Context = NonEmpty then
    NewLine;
  FWriter.Write(CloseBracket);
  Result := Self;
end;

procedure TTMSWEBJSONWriter.Close;
begin
  if (FStackSize > 1) or ((FStackSize = 1) and (PeekScope <> TTMSWEBJSONScope.jscNonEmptyDocument)) then
    raise EInvalidNesting.Create;
end;

constructor TTMSWEBJSONWriter.Create(const aStream: TStream);
begin
  inherited Create;
  FWriter := TTMSWEBJSONStreamWriter.Create(aStream);
  FSeparator := ':';
  PushScope(TTMSWEBJSONScope.jscEmptyDocument);
end;

destructor TTMSWEBJSONWriter.Destroy;
begin
  FWriter.Free;
  inherited;
end;

procedure TTMSWEBJSONWriter.NewLine;
var
  I: integer;
begin
  if FIndent <> '' then
  begin
    FWriter.Write(#13#10);
    for I := 1 to FStackSize - 1 do
      FWriter.Write(FIndent);
  end;
end;

function TTMSWEBJSONWriter.OpenItem(const Empty: TTMSWEBJSONScope;
  const OpenBracket: string): TTMSWEBJSONWriter;
begin
  BeforeValue(true);
  PushScope(Empty);
  FWriter.Write(OpenBracket);
  Result := Self;
end;

function TTMSWEBJSONWriter.PeekScope: TTMSWEBJSONScope;
begin
  if FStackSize = 0 then
    raise EEmptyJson.Create;
  Result := FStack[FStackSize - 1];
end;

procedure TTMSWEBJSONWriter.PushScope(const Scope: TTMSWEBJSONScope);
begin
  if FStackSize > MaxStackSize then
    raise ETooManyDepthLevels.Create;
  FStack[FStackSize] := Scope;
  Inc(FStackSize);
end;

procedure TTMSWEBJSONWriter.ReplaceTop(const Scope: TTMSWEBJSONScope);
begin
  if FStackSize = 0 then
    raise EEmptyJson.Create;
  FStack[FStackSize - 1] := Scope;
end;

procedure TTMSWEBJSONWriter.SetIndentLength(const Value: integer);
begin
  if Value <= 0 then
  begin
    FIndent := '';
    FSeparator := ':';
  end else
  begin
    FIndent := StringOfChar(#32, Value);
    FSeparator := ': ';
  end;
end;

function TTMSWEBJSONWriter.GetIndentLength: integer;
begin
  Result := Length(FIndent);
end;

procedure TTMSWEBJSONWriter.InternalWriteString(const Value: string);
begin
  FWriter.Write('"');
  FWriter.Write(TTMSWEBUtils.EscapeString(Value));
  FWriter.Write('"');
end;

function TTMSWEBJSONWriter.WriteString(const Value: string): TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  InternalWriteString(Value);
  Result := Self;
end;

function TTMSWEBJSONWriter.WriteEndArray: TTMSWEBJSONWriter;
begin
  Result := CloseItem(TTMSWEBJSONScope.jscEmptyArray, TTMSWEBJSONScope.jscNonEmptyArray, ']');
end;

function TTMSWEBJSONWriter.WriteEndObject: TTMSWEBJSONWriter;
begin
  Result := CloseItem(TTMSWEBJSONScope.jscEmptyObject, TTMSWEBJSONScope.jscNonEmptyObject, '}');
end;

function TTMSWEBJSONWriter.WriteBeginArray: TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  Result := OpenItem(TTMSWEBJSONScope.jscEmptyArray, '[');
end;

function TTMSWEBJSONWriter.WriteBeginObject: TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  Result := OpenItem(TTMSWEBJSONScope.jscEmptyObject, '{');
end;

function TTMSWEBJSONWriter.WriteBoolean(const Value: boolean): TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  if Value then
    FWriter.Write('true')
  else
    FWriter.Write('false');
    Result := Self;
end;

procedure TTMSWEBJSONWriter.WriteDeferredName;
begin
  if FDeferredName <> '' then
  begin
    BeforeName;
    InternalWriteString(FDeferredName);
    FDeferredName := '';
  end;
end;

function TTMSWEBJSONWriter.WriteDouble(const Value: double): TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  FWriter.Write(TTMSWEBUtils.FloatToStrDot(Value));
  Result := Self;
end;

function TTMSWEBJSONWriter.WriteName(const Name: string): TTMSWEBJSONWriter;
begin
  if Name = '' then
    raise EEmptyName.Create;
  if FDeferredName <> '' then
    raise EMissingValue.Create;
  if FStackSize = 0 then
    raise EEmptyJson.Create;
  FDeferredName := Name;
  Result := Self;
end;

function TTMSWEBJSONWriter.WriteNull: TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  FWriter.Write('null');
  Result := Self;
end;

function TTMSWEBJSONWriter.WriteRawString(const Value: string): TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  FWriter.Write('"');
  FWriter.Write(Value);
  FWriter.Write('"');
  Result := Self;
end;

function TTMSWEBJSONWriter.WriteInteger(const Value: Int64): TTMSWEBJSONWriter;
begin
  WriteDeferredName;
  BeforeValue(false);
  FWriter.Write(IntToStr(Value));
  Result := Self;
end;

{ TTMSWEBJSONStreamWriter }

constructor TTMSWEBJSONStreamWriter.Create(aStream: TStream);
begin
  FStream := aStream;
  FWriteStream := TStringStream.Create(''{$IFDEF WEBLIB}, TEncoding.Ansi{$ENDIF});
end;

destructor TTMSWEBJSONStreamWriter.Destroy;
begin
  try
    FWriteStream.Position := 0;
    FStream.CopyFrom(FWritestream, FWriteStream.Size);
  finally
    FWriteStream.Free;
  end;
  inherited;
end;

procedure TTMSWEBJSONStreamWriter.Write(const Value: string);
begin
  FWriteStream.WriteString(Value);
end;

{ TTMSWEBJSONWriter.ECannotWriteName }

constructor TTMSWEBJSONWriter.ECannotWriteName.Create;
begin
  inherited Create('Cannot write name in current Json scope');
end;

{ TTMSWEBJSONWriter.EMultipleRootNotAllowed }

constructor TTMSWEBJSONWriter.EMultipleRootNotAllowed.Create;
begin
  inherited Create('Multiple root values not allowed');
end;

{ TTMSWEBJSONWriter.EObjectOrArrayExpected }

constructor TTMSWEBJSONWriter.EObjectOrArrayExpected.Create;
begin
  inherited Create('Object or array expected as top-level value');
end;

{ TTMSWEBJSONWriter.EInvalidNesting }

constructor TTMSWEBJSONWriter.EInvalidNesting.Create;
begin
  inherited Create('Invalid nesting. Not all arrays/objects were properly closed.');
end;

{ TTMSWEBJSONWriter.EMissingValue }

constructor TTMSWEBJSONWriter.EMissingValue.Create;
begin
  inherited Create('Json value missing');
end;

{ TTMSWEBJSONWriter.ETooManyDepthLevels }

constructor TTMSWEBJSONWriter.ETooManyDepthLevels.Create;
begin
  inherited Create('Maximum level of nested structured reached.');
end;

{ TTMSWEBJSONWriter.EEmptyJson }

constructor TTMSWEBJSONWriter.EEmptyJson.Create;
begin
  inherited Create('Json is still empty. Cannot perform operation.');
end;

{ TTMSWEBJSONWriter.EEmptyName }

constructor TTMSWEBJSONWriter.EEmptyName.Create;
begin
  inherited Create('Cannot write empty name');
end;

end.
